RivalIQ.module('graph', function (graph, App, Backbone, Marionette, $, _, d3) {

    'use strict';

    let GraphId = 1;

    function Graph(attrs) {
        this.target = null;
        this.data = null;

        this.width = 400;
        this.height = (window.innerHeight > 775 ? 400 + (window.innerHeight - 775) : 330);
        this.margin = {
            top: 30,
            right: 100,
            bottom: 10,
            left: 250
        };
        this.ticks = 5;
        this.markerSize = 10;
        this.isContentLinkable = false;
        this.graphID = GraphId++;

        _.extend(this, attrs);
    }

    graph.Graph = Graph;

    Graph.EXCLUDED_LEGEND_CLASS_NAME = 'x-legend-excluded';

    Graph.prototype.setTarget = function (target) {
        this.target = target;
    };

    Graph.prototype.setData = function (data) {
        this.data = data;
    };

    Graph.prototype.setDataDateRange = function (dataDateRange) {
        this.dataDateRange = dataDateRange;
    };

    Graph.prototype.setWidth = function (width) {
        this.width = width;
    };

    Graph.prototype.setHeight = function (height) {
        this.height = height;
    };

    Graph.prototype.setMargins = function (margins) {
        this.margin = margins;
    };
    Graph.prototype.setMarginLeft = function (val) {
        this.margin.left = val;
    };
    Graph.prototype.setMarginRight = function (val) {
        this.margin.right = val;
    };
    Graph.prototype.render = function () {

    };

    Graph.prototype.setXLabel = function (label) {
        this.xlabel = label;
    };

    Graph.prototype.setYLabel = function (label) {
        this.ylabel = label;
    };

    Graph.prototype.setFormatX = function (format) {
        if (_.isFunction(format)) {
            this.formatX = format;
        } else {
            this.formatX = d3.format(format);
        }
    };

    Graph.prototype.setPopoverFormatX = function (format) {
        if (_.isFunction(format)) {
            this.popoverFormatX = format;
        } else if (format) {
            this.popoverFormatX = d3.format(format);
        }
    };

    Graph.prototype.setFormatY = function (format) {
        if (_.isFunction(format)) {
            this.formatY = format;
        } else {
            this.formatY = d3.format(format);
        }
    };

    Graph.prototype.formatForPopover = function (value) {
        if (this.popoverFormatX) {
            return this.popoverFormatX(value);
        }
        return this.formatX(value);
    };

    Graph.prototype.setAxisTicks = function (ticks) {
        this.axisTicks = ticks;
    };

    Graph.prototype.setMarkerSize = function (size) {
        this.markerSize = size;
    };

    Graph.prototype.setIsContentLinkable = function (isContentLinkable) {
        this.isContentLinkable = isContentLinkable;
    };

    Graph.prototype.setTimePeriod = function (timePeriod) {
        const me = this;
        const duration = _.get(timePeriod, 'mainPeriodDuration');
        if (!_.isFinite(duration)) {
            throw new Error('graphs require hydrated time periods');
        }
        me.timePeriod = timePeriod;
    };

    Graph.prototype.clearRendering = function () {
        $(this.target).find('*').remove();
    };

    Graph.prototype.trimOrdinalLabel = function (label, l) {
        if (typeof label === 'undefined') {
            return null;
        } else if (label.length > l) {
            return `${label.slice(0, l)}...`;
        } else {
            return label;
        }
    };

    Graph.prototype.trimOrdinalLabelWithFocus = function (d, l) {
        const label = d.label;
        if (d.focus) {
            l = 2 * l;
        }
        if (typeof label === 'undefined') {
            return null;
        } else if (label.length > l) {
            return `${label.slice(0, l)}...`;
        } else {
            return label;
        }
    };

    // Based on the example from http://bl.ocks.org/mbostock/7555321
    Graph.prototype.wrap = function (text, width) {
        text.each(function () {
            const text = d3.select(this);
            const value = (text.attr('data-text') || text.text());
            const words = value.split(/\s+/).reverse();
            let word;
            let line = [];
            let lineNumber = 0;
            const lineHeight = 1; // ems
            const y = text.attr('y');
            const x = text.attr('x');
            const dy = parseFloat(text.attr('dy'));
            let tspan = text.text(null).append('tspan').attr('x', x).attr('y', y).attr('dy', `${dy}em`);

            text.attr('data-text', value);

            for (word = words.pop(); word; word = words.pop()) {
                line.push(word);
                tspan.text(line.join(' '));

                if (tspan.node().getComputedTextLength() > width) {
                    line.pop();
                    tspan.text(line.join(' '));
                    line = [word];
                    tspan = text.append('tspan').attr('x', x).attr('y', y).attr('dy', `${++lineNumber * lineHeight + dy}em`).text(word);
                }

            }
        });
    };

}, window.d3);
